<template>
  <div
    class="bg-white w-100 d-flex justify-content-between align-items-center px-2 py-3 d-md-none main-container"
    v-if="!hidePwaPrompt && deferredPrompt"
  >
    <div>
      <button class="border rounded-circle text-muted cancel-button" @click="hidePrompt()">
        <i class="fas fa-times"></i>
      </button>
      <span class="font-weight-bold pl-2">Add to homescreen</span>
    </div>

    <button class="rounded-pill border-0 text-white px-4 py-2 install-button" @click="installPWA">Add</button>
  </div>
</template>

<script>

const oneWeek = 7 * 24 * 60 * 60 * 1000

export default {
  created() {
    this.hidePwaPrompt = !this.isPwaPromptDatePeriodPassed()
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPrompt = e
    })

    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
    });
  },
  data() {
    return {
      deferredPrompt: null,
      hidePwaPrompt: true,
    }
  },
  methods: {
    hidePrompt() {
      this.hidePwaPrompt = true
      localStorage.setItem('lastPwaPromptedAt', new Date().toISOString());
    },
    isPwaPromptDatePeriodPassed() {
      const lastPromptDate = localStorage.getItem('lastPwaPromptedAt');

      if (! lastPromptDate) {
        return true
      }
      const now = new Date();
      return now - new Date(lastPromptDate) > oneWeek
    },
    async installPWA() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;
        if (outcome === 'accepted') {
          console.log('User accepted the PWA installation');
        } else {
          console.log('User dismissed the PWA installation');
        }
        this.deferredPrompt = null
        this.hidePwaPrompt = true
      }
    },
  },
}
</script>

<style scoped>

.main-container {
  z-index: 2;
  position: fixed;
  bottom: 0;
  left: 0;
  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.cancel-button {
  height: 25px;
  width: 25px;
}

.install-button {
  background-color: #d6b674;
}

</style>
